// src/utils/api.js
import axios from 'axios';

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || '/api';

const api = axios.create({ baseURL: apiBaseUrl });

api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('crm_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  r => r,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('crm_token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
